/* eslint-disable */

import React from 'react';
import styled from 'styled-components';
import { space, width, style } from 'styled-system';
import PropTypes from 'prop-types';

const tag = (blacklist = []) => {
    const clean = cleanProps(blacklist);

    return type => {
        const Base = props => {
            const isEl = typeof type === 'string';
            const Comp = isEl ? props.is || type : type;
            const next = isEl ? clean(props) : props;

            if (isEl) {
                next.is = null;
            }

            return <Comp {...next} />;
        };

        return Base;
    };
};

const cleanProps = blacklist => props => {
    const next = {};
    for (const key in props) {
        if (blacklist.includes(key)) {
            continue;
        }
        next[key] = props[key];
    }

    return next;
};

const responsivePropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]);

const propTypes = {
    width: responsivePropType,
    fontSize: responsivePropType,
    color: responsivePropType,
    bg: responsivePropType,
    m: responsivePropType,
    mt: responsivePropType,
    mr: responsivePropType,
    mb: responsivePropType,
    ml: responsivePropType,
    mx: responsivePropType,
    my: responsivePropType,
    p: responsivePropType,
    pt: responsivePropType,
    pr: responsivePropType,
    pb: responsivePropType,
    pl: responsivePropType,
    px: responsivePropType,
    py: responsivePropType
};

const flex = style({ prop: 'flex' });
const order = style({ prop: 'order' });

const removeProps = [
    'width',
    'w',
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'flex',
    'order',
    'wrap',
    'direction',
    'align',
    'justify',
    'column'
];

const Tag = tag(removeProps);
const Base = Tag('div');

const Box = styled(Base)([], { boxSizing: 'border-box' }, width, space, flex, order);
Box.displayName = 'Box';

Box.propTypes = Object.assign({}, propTypes, {
    flex: responsivePropType,
    order: responsivePropType
});

const align = props => ({ verticalAlign: props.align || 'top' });

const Grid = styled(Box)(
    [],
    {
        display: 'inline-block'
    },
    align
);
Grid.displayName = 'Grid';

export default Grid;
